import { createContext, Component } from "react";

export const AuthContext = createContext();

class AuthContextProvider extends Component {
  constructor() {
    super();;
    console.log("session", JSON.parse(sessionStorage.getItem("UserData")));

    const user = JSON.parse(sessionStorage.getItem("UserData")) || {};
    // const blockEndTime = parseInt(sessionStorage.getItem("blockEndTime"),10) || null;
    console.log("auth user", user.sessList || []);
    // console.log("session UserData", JSON.parse(sessionStorage.getItem("UserData")));
    // console.log("session", JSON.parse(sessionStorage.getItem("UserData")));
    // const AuthorizedSessions = JSON.parse(sessionStorage.getItem("AuthorizedSessions"));
    let menuNames = [];

    if (user.UserData?.field_1) {
      // let accessibleMenus = user?.accessibleMenu;
      // accessibleMenus?.forEach((value) => {
      //   menuNames.push(value.SessionName);
      // });
      this.state = {
        emp_name: user.UserData.field_2,
        godrej_email_id: user.UserData.field_2,
        role_code: "",
      //  company_code: user.UserData.company_code,
        authorizedSessions: user.sessList,
        token: user.Token,
        // blockEndTime: blockEndTime
      };
    }else { 
       this.state = {
         emp_name: null,
         godrej_email_id: null,
          role_code: null,
           company_code: null, 
           authorizedSessions: [],
            token: null,
            //  blockEndTime: blockEndTime
             };
             }
    console.log("this.state", this.state);
  }


  render() {
    return (
      <AuthContext.Provider value={{ ...this.state }}>
        {this.props.children}
      </AuthContext.Provider>
    );
  }
}

export default AuthContextProvider;
